var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenTick = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2682_44966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4682 0.274438C10.3993 0.201538 10.3175 0.143676 10.2272 0.104189C10.137 0.0647021 10.0402 0.0443726 9.9425 0.0443726C9.84476 0.0443726 9.74799 0.0647021 9.65777 0.104189C9.56754 0.143676 9.48566 0.201538 9.41683 0.274438L3.90096 6.07666L1.58356 3.63444C1.5121 3.56192 1.42773 3.5049 1.33529 3.46663C1.24285 3.42836 1.14414 3.40959 1.0448 3.4114C0.945452 3.4132 0.847418 3.43554 0.756292 3.47715C0.665167 3.51876 0.582735 3.57881 0.513702 3.65388C0.44467 3.72896 0.39039 3.81758 0.35396 3.91469C0.31753 4.01179 0.299664 4.11549 0.301383 4.21985C0.303102 4.32422 0.324371 4.4272 0.363977 4.52293C0.403583 4.61866 0.460749 4.70525 0.532212 4.77777L3.37529 7.76444C3.44412 7.83734 3.52601 7.8952 3.61623 7.93469C3.70645 7.97417 3.80322 7.9945 3.90096 7.9945C3.9987 7.9945 4.09547 7.97417 4.1857 7.93469C4.27592 7.8952 4.35781 7.83734 4.42664 7.76444L10.4682 1.41777C10.5433 1.34494 10.6033 1.25654 10.6443 1.15815C10.6853 1.05977 10.7065 0.953517 10.7065 0.846105C10.7065 0.738692 10.6853 0.632444 10.6443 0.534055C10.6033 0.435667 10.5433 0.347271 10.4682 0.274438Z",
    fill: "#1C9240"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2682_44966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 8,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/green-tick.a91ecbf0ca196a1fb055e3e3b1c13744.svg";